import Grid from "@mui/material/Grid2";
import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../../axios/axios";
import { END_POINTS } from "../../../shared";
import Skeleton from "react-loading-skeleton";
import { toast } from "react-toastify";
import { useTheme } from "@mui/material/styles";
import CredentionalDetails from "./CredentionalDetails";
import CredentionalList from "./Credentionallist";
import { SkeletonLoader } from "../../../modules/dashboard/shared";


const CredentionalMgmt = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const [isLoading, setIsLoading] = useState(false);
  const [agentData, setAgentData] = useState<any>([]);
  const [leftSkeletonCount, setLeftSkeletonCount] = useState(0);
  const [rightSkeletonCount, setRightSkeletonCount] = useState(0);
  const leftGridRef = useRef<HTMLDivElement>(null);
  const rightGridRef = useRef<HTMLDivElement>(null);
  const [addAgentList, setAddAgentList] = useState<any>(null);
  const [credintialsData, setCredintialsData] = useState<any[]>([]);
  const [activeCredential, setActiveCredential] = useState<any>(null); // State for the selected credential
  const [creationType, setCreationType] = useState<string | undefined>(undefined); // State for creation type (local/global)

  const handleActiveCredentialChange = (credential: any) => {
    setActiveCredential(credential);
    setCreationType(undefined); // Reset creation type when selecting an existing credential
  };

  const pageRefresh = () => {
    setActiveCredential(null);
    fetchCredinalsList();
  }

  const fetchCredinalsList = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(END_POINTS.CREDENTIAL_MGMT);
      if (response.status === 200) {
        const data = response.data?.data?.cred_list || [];
        setCredintialsData(data);
      }
    } catch (error: any) {
      console.error("Error fetching agent list:", error.response);
      toast.error(
        error.response?.data?.message || "Something went wrong",
        { type: "error" }
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCredinalsList();

  }, []);

  const handleCreateNewCredential = (type: string) => {
    setActiveCredential(null)
    setActiveCredential(null); // Clear active credential
    setCreationType(type); // Set creation type (local/global)

  };

  useEffect(() => {
    if (leftGridRef.current) {
      const gridHeight = leftGridRef.current.offsetHeight;
      const count = Math.floor(gridHeight / 40);
      setLeftSkeletonCount(count);
    }
    if (rightGridRef.current) {
      const gridHeight = rightGridRef.current.offsetHeight;
      const count = Math.floor(gridHeight / 40);
      setRightSkeletonCount(count);
    }
  }, [isLoading]);

  return (
    <>
      {isLoading ? (
        <div
          style={{
            height: "calc(100vh - 104px)",
            width: "100%",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <Grid container spacing={2} sx={{ height: "100%" }}>
            <Grid
              size={2.5}
              sx={{
                height: "100%",
              }}
              ref={leftGridRef}
            >
              <SkeletonLoader
                count={Math.floor(window.innerHeight / 40)}
                styles={{ height: 30 }}
              />
            </Grid>
            <Grid
              size={9.5}
              sx={{
                height: "100%",
              }}
              ref={rightGridRef}
            >
              <SkeletonLoader
                count={Math.floor(window.innerHeight / 40)}
                styles={{ height: 30 }}
              />
            </Grid>
          </Grid>
        </div>
      ) : (
        <div>
          <Grid container spacing={2} sx={{
            height: "100%"
          }}>
            <Grid size={2.5} sx={{
              height: "100%"
            }}
            >
              <CredentionalList
                onActiveCredentialChange={handleActiveCredentialChange} // Pass handler to update active credential
                onCreateNewCredential={handleCreateNewCredential}
                isDarkMode={isDarkMode}
                credintialsData={credintialsData}
              />
            </Grid>
            <Grid size={9.5}>
              <CredentionalDetails
                credential={activeCredential} // Pass active credential as prop
                creationType={creationType} // Pass creation type as prop
                isDarkMode={isDarkMode}
                pageReload={pageRefresh}
              />
            </Grid>
          </Grid>

        </div>
      )}
    </>
  );
};

export default CredentionalMgmt;